import PropTypes from 'prop-types';
//constants
import { validationTypes } from 'components/FormCreator/types';
import {  paymentsMethodType } from 'constants/beneficiary.constants';

export type formPropType = {
	children: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	isOptional: boolean;
	handleChange: any;
	setOptionalPayments: any;
	optionalPayments: paymentsMethodType;
	payment: string;
	disabled?: boolean;
};

export const fieldsValidations = {
	acctNumber: [validationTypes.requierd, validationTypes.min5Chars],
	bicSwift: [validationTypes.requierd],
	iban: [validationTypes.requierd],
	bankAccountHolderName: [validationTypes.requierd, validationTypes.min3Chars],
	bankAccountCountryId: [validationTypes.requierd],
	bankCurrency: [validationTypes.requierd],
};
